var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center pt-2"},[(_vm.colorHex)?_c('span',{staticClass:"dot",class:{ formDot: _vm.form },style:({ backgroundColor: _vm.colorHex })}):_vm._e(),(_vm.colorArray)?_c('span',{staticClass:"dot",class:{ formDot: _vm.form },style:({ backgroundColor: _vm.convertColorArrayToHex })}):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.column))])])
}
var staticRenderFns = []

export { render, staticRenderFns }